<!--
<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg5 xl4>
            <v-card >
                <v-toolbar dark color="blue darken-3">
                    <v-toolbar-title>
                        Access
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-text-field  autofocus v-model="username"  color="accent" label="Username" required>
                    </v-text-field>
                    <v-text-field v-model="password" type="password" color="accent" label="Password" requiered>
                    </v-text-field>
                    <v-flex v-if="error" class="red--text">
                        {{error}}
                    </v-flex>
                </v-card-text>
                <v-card class="d-flex justify-end">
                    <v-card-actions  >
                        <v-flex >
                            <v-btn @click="LogIn" color="primary"
                                :disabled="dialogLoading"
                                :loading="dialogLoading"
                            >
                                LogIn
                            </v-btn>
                            <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    LogIn, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>


                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-card>
        </v-flex>
    </v-layout>
</template>
-->


<template>
  <section
    id="welcome"
    class="overflow-hidden"  
  >
    <v-row no-gutters dense
    
    >
      <v-col
        class="hidden-sm-and-down justify-center "
        md="6"
        align="center"
        
      >
      
       <v-btn @click="LogInProduction" color="blue-grey lighten-4" 
                                :disabled="dialogLoading"
                                :loading="dialogLoading"
                            >
                                Welcome Production
                            </v-btn>
                            <br> <br><br> <br>
        <v-img
          :src="require('@/assets/Production.gif')"         
          height="40hv"
        />
        
      </v-col>
        <v-col
        class="white white--text rounded justify-center"
        cols="1"
        md="1"
        
        >
        </v-col>

      <v-col
        class="align-content-space-between layout wrap light-blue lighten-5  rounded justify-center"
         align="center"
        :pa-5="$vuetify.breakpoint.smAndDown"
        cols="5"
        md="4"
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateY(25%)"
        />

        

        <v-row
          align="center"
          justify="center"
          
        >
          <v-col 
          >
            
            <!-- class="white--text" -->
            <base-text  >
                      
                    
             This section is especially for users who require special access to different functions according to their department. 
           
            </base-text>         

           

        

        <v-sheet
          color="transparent"
          max-width="600"
          
          rounded="rounded"
        >
         

          <v-card >
                <v-toolbar dark color="light-blue accent-4">
                    <v-toolbar-title>
                        Access
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-text-field  autofocus v-model="username"  color="accent" label="Username" required>
                    </v-text-field>
                    <v-text-field v-model="password" type="password" color="accent" label="Password" requiered>
                    </v-text-field>
                    <v-flex v-if="error" class="red--text">
                        {{error}}
                    </v-flex>
                </v-card-text>
                <v-card class="d-flex justify-end">
                    <v-card-actions  >
                        <v-flex >
                            <v-btn @click="LogIn" color="light-blue accent-4" dark
                                :disabled="dialogLoading"
                                :loading="dialogLoading"
                            >
                                LogIn
                            </v-btn>
                            <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    LogIn, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>


                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-card>
       
       
       
        </v-sheet>



            
          </v-col>
        </v-row>

        <base-bubble-2
          style="transform: rotate(180deg) translate(-200px, -15%)"
        />
      </v-col>
    </v-row>
  </section>
</template>




<script>
    import axios from 'axios';

    export default {
        data (){
            return {
                elevations: [24, 24],
                username: '',
                password: '',
                error: null,
                 dialogLoading: false,
            }            
        },
           watch: {            
             dialogLoading (val)  {
                if (!val) return
            }          
        },
         created () {         
            axios.defaults.baseURL = this.$hostname;                        
        },
        //For Doit 2FA, begin
        async mounted(){
            const me = this;
            //axios.post('api/Usuarios/DoitRedi',{userName: this.username, password: this.password})
            await axios.post("api/Usuarios/DoitRedi", {CV: 'DOITLOGIN'})
                        .then((Response) => {
                        console.log(Response.data);
                        if (Response.data.mess[0].mess == 'N') {  }
                        else { 
                            console.log(Response.data.mess[0].mess)
                            //window.location.href = 'https://doit.foxconn.com/andon/v2/?m=login&sys_id=7&session_id='+Response.data.mess[0].mess;
                            window.location.href = Response.data.mess[1].mess + Response.data.mess[0].mess;
                            console.log(window.location.href);
                        }
                        })
                        .catch((err) => {
                        console.log('err: ',err)
                        })
                        .finally(() => (this.dialogLoading = false));

        },
       //For Doit 2FA, end
        methods: {
            LogIn() {
                    this.dialogLoading = true;
                    this.error=null;                    
                    axios.post('api/Usuarios/Login',{userName: this.username, password: this.password})
                    .then(response => {
                        return response.data
                    })
                    .then(data =>{
                        this.$store.dispatch("saveToken",data.token);
                        this.$router.push({name: 'Home'})
                    }).catch(err => {
                        if (err.response.status==404)
                        {
                            this.error = "The user does not exist or has entered invalid information." ;
                        }
                        else
                        {
                            this.error = "An error has occurred.";
                        }                        
                        }).finally(() => this.dialogLoading  = false
                        
                    );                     
                },
                LogInProduction() {
                    this.username = 'production';
                    this.password = 'Foxconn123_RaMa';
                    this.dialogLoading = true;
                    this.error=null;                    
                    axios.post('api/Usuarios/Login',{userName: this.username, password: this.password})
                    .then(response => {
                        return response.data
                    })
                    .then(data =>{
                        this.$store.dispatch("saveToken",data.token);
                        this.$router.push({name: 'Home'})
                    }).catch(err => {
                        if (err.response.status==404)
                        {
                            this.error = "The user does not exist or has entered invalid information." ;
                        }
                        else
                        {
                            this.error = "An error has occurred.";
                        }                        
                        }).finally(() => this.dialogLoading  = false
                        
                    );                     
                }

        }
    }
</script>